import { useContext } from "react"
import { APIContext } from "../APIProvider"

export const useApi = () => {
  return useContext(APIContext)
}
